/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BaseResponseDto_AnyResponseDto } from '../models/BaseResponseDto_AnyResponseDto';
import type { CreateResponseDto_AnyResponseDto } from '../models/CreateResponseDto_AnyResponseDto';
import type { FaqAddDto } from '../models/FaqAddDto';
import type { FaqUpdateDto } from '../models/FaqUpdateDto';
import type { OperationResponseDto } from '../models/OperationResponseDto';
import type { PaginatedResponse_AnyResponseDto } from '../models/PaginatedResponse_AnyResponseDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class FaqService {
    /**
     * FAQ列表
     * @param pn 页码
     * @param rn 每页数量
     * @param custom 自定义模糊查询
     * @returns PaginatedResponse_AnyResponseDto 获取成功
     * @throws ApiError
     */
    public static ycFaqControllerGet(
        pn: number = 1,
        rn: number = 10,
        custom?: string,
    ): CancelablePromise<PaginatedResponse_AnyResponseDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/back/faq',
            query: {
                'pn': pn,
                'rn': rn,
                'custom': custom,
            },
            errors: {
                400: `参数错误`,
                401: `未授权`,
                403: `禁止访问`,
                404: `资源不存在`,
                500: `服务器内部错误`,
            },
        });
    }
    /**
     * 新增FAQ
     * @param requestBody
     * @returns CreateResponseDto_AnyResponseDto 创建成功
     * @throws ApiError
     */
    public static ycFaqControllerAdd(
        requestBody: FaqAddDto,
    ): CancelablePromise<CreateResponseDto_AnyResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/back/faq',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `参数错误`,
            },
        });
    }
    /**
     * 更新FAQ
     * @param requestBody
     * @returns OperationResponseDto 更新成功
     * @throws ApiError
     */
    public static ycFaqControllerPut(
        requestBody: FaqUpdateDto,
    ): CancelablePromise<OperationResponseDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/back/faq',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `参数错误`,
                401: `未授权`,
                403: `禁止访问`,
                404: `资源不存在`,
                500: `服务器内部错误`,
            },
        });
    }
    /**
     * FAQ详情
     * @param id
     * @returns BaseResponseDto_AnyResponseDto 获取成功
     * @throws ApiError
     */
    public static ycFaqControllerGetDetail(
        id: string,
    ): CancelablePromise<BaseResponseDto_AnyResponseDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/back/faq/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `参数错误`,
                401: `未授权`,
                403: `禁止访问`,
                404: `资源不存在`,
                500: `服务器内部错误`,
            },
        });
    }
    /**
     * 删除FAQ
     * @param id
     * @returns OperationResponseDto 删除成功
     * @throws ApiError
     */
    public static ycFaqControllerDelete(
        id: number,
    ): CancelablePromise<OperationResponseDto> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/back/faq/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `参数错误`,
                401: `未授权`,
                403: `禁止访问`,
                404: `资源不存在`,
                500: `服务器内部错误`,
            },
        });
    }
}
